<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container [formGroup]="accountInformations">
      <div class="row">
        <div class="col-md-12">
          <pr-input-radio
            [derrors]="derrors"
            formControlName="financialKnowledgeLevel"
            direction="column"
            [isDefault]="false"
            columns="4"
            [options]="knowledgeFinancialAssetsOptions"
            label="Quelle est votre connaissance des marchés financiers ?"
          >
          </pr-input-radio>
        </div>
        <div class="col-md-12">
          <pr-input-radio
            [derrors]="derrors"
            formControlName="realEstateKnowledgeLevel"
            direction="column"
            [isDefault]="false"
            columns="4"
            [options]="knowledgeFinancialAssetsOptions"
            label="Quelle est votre connaissance des marchés Immobiliter ?"
          >
          </pr-input-radio>
        </div>
      </div>
    </ng-container>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
